import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { authApi } from "../api/axios";
import { useAuth } from "../auth/useAuth";
import Spinner from "../components/Spinner";

function VerifyOtp() {
  const navigate = useNavigate();
  const { loginFromResponse, isAuthenticated } = useAuth();

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("otpUserId");

    if (!userId) {
      toast.error("Missing user ID. Please login again.");
      navigate("/login");
      return;
    }

    setLoading(true);

    try {
      const { data } = await authApi.post("/account/verifyOtp", {
        userId,
        otp,
      });

      if (data.success) {
        // Pass the full response — loginFromResponse extracts token,
        // userProfile, expiresIn, AND refreshToken. Filtering here
        // would drop the refresh token, which the JWT-tied refresh
        // flow in SessionProvider needs to rotate the access token
        // before it expires.
        loginFromResponse?.(data);

        localStorage.removeItem("otpUserId");

        navigate("/search");
      } else {
        toast.error(data.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "An error occurred during OTP verification.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/search");
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold mb-1 mt-10">Verify OTP</h2>

        <p className="text-gray-500 text-sm">
          Enter the 6-digit OTP sent to your registered email.
        </p>
      </div>

      <form
        onSubmit={handleOtpSubmit}
        className="w-full max-w-sm mx-auto space-y-6"
      >
        <div className="flex justify-center">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputType="tel"
            renderInput={(props) => (
              <input
                {...props}
                style={{ width: "48px", height: "56px" }}
                className="border-2 border-gray-300 rounded-xl text-center text-xl font-semibold focus:outline-none focus:ring-2 focus:ring-primaryColor"
              />
            )}
            containerStyle="flex gap-3"
          />
        </div>

        <button
          type="submit"
          disabled={loading || otp.length !== 6}
          className="w-full flex items-center justify-center bg-primaryColor text-white py-3 rounded-md text-sm hover:bg-secondaryColor transition-colors duration-300 disabled:cursor-not-allowed"
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <Spinner size={16} />
              <span>Verifying...</span>
            </span>
          ) : (
            "Verify OTP"
          )}
        </button>
      </form>
    </>
  );
}

export default VerifyOtp;
